const selectorTextEditable = `
  [contenteditable="true"],
  [contenteditable=""],
  textarea, 
  select,
  input:not([type="button"], [type="submit"], [type="reset"], [type="radio"], [type="checkbox"])
`;

/**
 * Checks if the event target is an input element or a contenteditable element.
 * This is useful for determining if keyboard navigation should be handled differently.
 *
 * @param event - The keyboard event to check.
 * @returns True if the event target is an input or contenteditable element, false otherwise.
 */
export function isEventTargetInput(event: KeyboardEvent): boolean {
    if (!event.target || !(event.target instanceof HTMLElement)) return false;

    const elEditable = event.target.closest(selectorTextEditable);
    return !!elEditable;
}
